<template>
  <validated-text-field
    :value="amount"
    rules="required|amount|min_value:0.5"
    :label="$t('label.price')"
    v-bind="$attrs"
    @input="priceChanged"
  />
</template>

<script setup lang="ts">

import { sprintf } from 'sprintf-js';
import {
  watch, ref, computed, PropType,
} from 'vue';

const props = defineProps({
  value: { type: [Number, undefined] as PropType<number|undefined>, required: true },
});
const emit = defineEmits(['input']);

const amtToCents = (val: string) => (val.match(/^\d+\.?\d?\d?$/) ? Math.round(parseFloat(val) * 100) : NaN);
const centsToAmt = (val: number | undefined) => {
  if (val === 0) { return '0'; }
  return val !== undefined ? sprintf('%.2f', val / 100) : '';
};

const amount = ref(centsToAmt(props.value));
const convertedAmount = computed(() => amtToCents(amount.value));

const priceChanged = (val: string) => {
  amount.value = val.replaceAll(',', '.');
  if (!Number.isNaN(convertedAmount.value)) {
    emit('input', convertedAmount.value);
  }
};

watch(() => props.value, () => {
  if (props.value && props.value === convertedAmount.value) {
    return;
  }
  amount.value = centsToAmt(props.value);
});

</script>
